import { render } from "./FeedFormulations.vue?vue&type=template&id=059999a4&scoped=true"
import script from "./FeedFormulations.vue?vue&type=script&lang=js"
export * from "./FeedFormulations.vue?vue&type=script&lang=js"

import "./FeedFormulations.vue?vue&type=style&index=0&id=059999a4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059999a4"]])

export default __exports__